import config from '@/config/config'
import CakeBaseLayout from '@/layout/CakeBaseLayout/index.vue'
import CakeLayout from '@/layout/CakeLayout/index.vue'



export const cakeTabMap = [
         {
           path: '/cake-tab',
           name: 'Cake',
           component: CakeLayout,
           redirect: '/cake-tab/cake-home',
           children: [
             {
               path: '/cake-tab/cake-home',
               name: 'CakeHome',
               component: () => import('@/views/cakeHome'),
               meta: {
                 name: '蛋糕首页',
                 noLogin: config.visitorMode
               },
               icon: {
                 active: require('@/assets/Tabbar/cake.svg'),
                 inactive: require('@/assets/Tabbar/cake.svg')
               }
             },
             {
               path: '/cake-tab/cake-brands',
               name: 'CakeBrands',
               component: () =>
                 import('@/views/cakeBrands'),
               meta: {
                 name: '蛋糕品牌',
                 noLogin: config.visitorMode
               },
               icon: {
                 active: require('@/assets/Tabbar/accategory.svg'),
                 inactive: require('@/assets/Tabbar/category.svg')
               }
             }
           ]
         }
       ]

export const cakeBaseRoute = [
         {
           path: '/cake',
           name: 'Cake',
           component: CakeBaseLayout,
           redirect: '/cake/cake-home',
           children: [
             {
               path: '/cake/cake-detail',
               name: 'CakeDetail',
               component: () =>
                 import('@/views/cakeDetail'),
               meta: {
                 name: '蛋糕详情',
                 noLogin: config.visitorMode
               }
             },
             {
               path: '/cake/cake-brand-detail',
               name: 'CakeBrandDetail',
               component: () =>
                 import('@/views/cakeBrandDetail'),
               meta: {
                 name: '品牌详情',
                 noLogin: config.visitorMode
               }
             },
             {
               path: '/cake/cake-deliver-goods',
               name: 'CakeDeliverGoods',
               component: () =>
                 import('@/views/cakeDeliverGoods'),
               meta: {
                 name: '蛋糕配送',
                 noLogin: config.visitorMode
               }
             }
           ]
         }
       ]
